import { useState } from 'react';
import { Plus, Save, Download, Upload } from 'lucide-react';
import ExcelGrid from '../components/ExcelGrid/ExcelGrid';

const FinancialModeling = () => {
  const [activeModel, setActiveModel] = useState<string | null>(null);
  const [scenario, setScenario] = useState<'optimistic' | 'realistic' | 'pessimistic'>('realistic');

  const handleCellChange = (row: number, col: number, value: string | number) => {
    console.log(`Cell changed: ${row},${col} = ${value}`);
    // TODO: Save to backend
  };

  const scenarios = [
    { id: 'optimistic', name: 'Optimistic', color: 'bg-success-100 text-success-800' },
    { id: 'realistic', name: 'Realistic', color: 'bg-primary-100 text-primary-800' },
    { id: 'pessimistic', name: 'Pessimistic', color: 'bg-alert-100 text-alert-800' },
  ];

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="px-6 py-4 bg-white border-b border-neutral-200">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-3xl font-bold text-neutral-900">Financial Modeling</h1>
            <p className="text-neutral-600 mt-1">
              Build and analyze financial models with Excel-like interface
            </p>
          </div>

          <div className="flex items-center space-x-2">
            <button className="btn btn-secondary">
              <Upload className="w-4 h-4 mr-2" />
              Import
            </button>
            <button className="btn btn-secondary">
              <Download className="w-4 h-4 mr-2" />
              Export
            </button>
            <button className="btn btn-primary">
              <Save className="w-4 h-4 mr-2" />
              Save Model
            </button>
            <button className="btn btn-success">
              <Plus className="w-4 h-4 mr-2" />
              New Model
            </button>
          </div>
        </div>

        {/* Scenario Tabs */}
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-neutral-700 mr-2">Scenario:</span>
          {scenarios.map((s) => (
            <button
              key={s.id}
              onClick={() => setScenario(s.id as any)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                scenario === s.id
                  ? s.color
                  : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
              }`}
            >
              {s.name}
            </button>
          ))}
        </div>
      </div>

      {/* Grid Container */}
      <div className="flex-1 p-6 bg-neutral-50">
        <div className="card p-0 h-full">
          <ExcelGrid
            rows={1000}
            cols={26}
            onCellChange={handleCellChange}
          />
        </div>
      </div>

      {/* Info Panel */}
      <div className="px-6 py-3 bg-white border-t border-neutral-200">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-4 text-neutral-600">
            <span>📊 Model: Q1 2025 Budget</span>
            <span>•</span>
            <span>👥 Collaborators: 3</span>
            <span>•</span>
            <span>💾 Last saved: 2 minutes ago</span>
          </div>

          <div className="flex items-center space-x-4">
            <span className="text-neutral-600">
              Keyboard shortcuts:{' '}
              <kbd className="px-2 py-1 bg-neutral-100 rounded text-xs">Ctrl+C</kbd> Copy,{' '}
              <kbd className="px-2 py-1 bg-neutral-100 rounded text-xs">Ctrl+V</kbd> Paste,{' '}
              <kbd className="px-2 py-1 bg-neutral-100 rounded text-xs">Enter</kbd> Edit
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialModeling;
